import { createRoot } from 'react-dom/client'
import { ContentPageApp } from '../template/content-pages/ContentPageApp'

const root = document.getElementById('nova-react-content-page')

if (root && !root.__novaReactRoot) {
  root.__novaReactRoot = createRoot(root)
  root.__novaReactRoot.render(<ContentPageApp payload={window.novaThemeReactContentPage || {}} />)
}
